import React from "react";


const About = () => {
  return (
    <div>
    

  {/* HEADER */}
  <section className="page-header">
    <div className="header-container">
      <h1>About Us</h1>
      <p>Learn more about Lifetime Infotech</p>
    </div>
  </section>

  {/* ABOUT SECTION */}

      {/* ABOUT SECTION */}

      <section className="about-section">
        <div className="about-container">

          <div className="about-image">
            <img src="/images/ab.jpg" alt="About Us" />
          </div>

          <div className="about-content">
            <h2>About Lifetime Infotech</h2>

            <p>
              Lifetime Infotech is a leading software development company
              dedicated to delivering innovative digital solutions for
              businesses around the world. We specialize in building
              high-quality web applications, mobile apps, and enterprise
              software that help businesses grow faster.
            </p>

            <p>
              Our team of experienced developers, designers, and strategists
              work together to create scalable and secure digital products.
              We focus on providing reliable, user-friendly, and performance-
              driven solutions tailored to each client's needs.
            </p>

          </div>

        </div>
      </section>

      {/* WHY CHOOSE US */}

      <section className="why-section">

        <div className="why-container">

          <div className="why-content">

            <h2>Why Choose Us</h2>

            <div className="why-item">
              <i className="bi bi-check-circle"></i>
              <p>Experienced team of professional developers</p>
            </div>

            <div className="why-item">
              <i className="bi bi-check-circle"></i>
              <p>High quality and scalable solutions</p>
            </div>

            <div className="why-item">
              <i className="bi bi-check-circle"></i>
              <p>Agile development methodology</p>
            </div>

            <div className="why-item">
              <i className="bi bi-check-circle"></i>
              <p>On-time project delivery</p>
            </div>

            <div className="why-item">
              <i className="bi bi-check-circle"></i>
              <p>24/7 customer support</p>
            </div>

          </div>

          <div className="why-image">
            <img src="/images/whychoose.jpg" alt="Why Choose Us" />
          </div>

        </div>

      </section>


      {/* MISSION & VISION */}

      <section className="mission-section">

        <div className="mission-container">

          <div className="mission-box">
            <i className="bi bi-bullseye"></i>
            <h3>Our Mission</h3>

            <p>
              Our mission is to empower businesses with innovative and
              reliable technology solutions that improve efficiency,
              productivity, and long-term growth.
            </p>
          </div>

          <div className="mission-box">
            <i className="bi bi-eye"></i>
            <h3>Our Vision</h3>

            <p>
              Our vision is to become a trusted global technology partner
              by delivering world-class digital solutions and exceptional
              customer experiences.
            </p>
          </div>

        </div>

      </section>

    </div>
  );
};

export default About;